import { IApplicationState } from '../../types/redux';

export const selectResultsStatus = (state: IApplicationState) => {
  return state.results.status;
};
